import React from "react";
import Box from "@mui/material/Box";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import { Link as RouterLink, useLocation } from "react-router-dom";
import UserInfo from "../components/user-info";
import UserProducts from "../components/user-products";
import { Eyebrow } from "../components/ui";
import { paths } from "./paths";
import { tokens } from "../styles/tokens";

/**
 * Account page. The two tabs are routed rather than held in a store, so the
 * devices tab is deep-linkable (home's "View all" points at it) and the browser
 * back button moves between them.
 */
export default function UserPage() {
  const { pathname } = useLocation();
  const onDevices = pathname === paths.accountDevices;

  return (
    <Box
      sx={{
        width: `min(100%, ${tokens.space.containerMax}px)`,
        mx: "auto",
        px: { mobile: 2.5, tablet: 4, laptop: 5 },
        py: { mobile: 4, laptop: 6 },
      }}
    >
      <Eyebrow>Account</Eyebrow>
      <Typography variant="h2" sx={{ mb: 3 }}>
        {onDevices ? "Registered devices." : "Your account."}
      </Typography>

      <Box sx={{ borderBottom: 1, borderColor: "divider", mb: 3 }}>
        <Tabs value={onDevices ? 1 : 0} aria-label="Account sections">
          <Tab label="User info" component={RouterLink} to={paths.account} />
          <Tab
            label="Registered devices"
            component={RouterLink}
            to={paths.accountDevices}
          />
        </Tabs>
      </Box>

      {onDevices ? <UserProducts /> : <UserInfo />}
    </Box>
  );
}
